<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="text-right leading-tight hidden sm:block">
        <p class="font-semibold">{{ activeUserInfo.username }}</p>
        <small>
          <span v-for="item in roles" :key="item.id">#{{ item.name }}</span>
        </small>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="changePassword"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">修改密码</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">个人中心</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">消息</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">任务</span>
          </li> -->

          <!-- <vs-divider class="m-1" /> -->

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Sign Out</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup title="修改密码" :active.sync="passwordModal" size="small">
      <div>
        <div style="padding-left: 135px; margin-top: 20px">
          <form>
            <div style="margin-bottom: 10px">
              <span style="color: black; margin-right: 5px">账号:</span
              >{{ activeUserInfo.username }}
            </div>
            <div>新密码<span style="color: red">&nbsp;*</span></div>
            <vs-input
              style="width: 300px; margin-bottom: 10px"
              type="password"
              v-model="password1"
              autocomplete
            />
            <div>确认密码<span style="color: red">&nbsp;*</span></div>
            <vs-input
              style="width: 300px; margin-bottom: 50px"
              type="password"
              v-model="password2"
              autocomplete
            />
          </form>
        </div>

        <vs-divider class="m-1" />
        <div style="padding-left: 385px; margin-top: 20px">
          <vs-button class="mr-3" @click="savePassword">保存</vs-button>
          <vs-button
            type="border"
            @click="closePasswordModal"
            id="password_reset"
            >取消</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import api from '@/repo/user.js'
export default {
  data() {
    return {
      activeUserInfo: null,
      passwordModal: false,
      password1: '',
      password2: '',
    }
  },
  props: {
    roles: {
      type: Array,
    },
  },

  mounted() {
    // console.log('user info:', this.$store.state.userInfo)
    if (this.$store.state.userInfo) {
      this.activeUserInfo = this.$store.state.userInfo
    }
  },
  methods: {
    ...mapMutations(['REMOVE_USER_INFO']),

    //退出登录
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.REMOVE_USER_INFO(this.$store.state.userInfo)
      this.$router.push('/login')
    },
    changePassword() {
      this.passwordModal = true
    },
    password_reset() {
      this.password1 = ''
      this.password2 = ''
      let a = setTimeout(() => {
        let btn = document.getElementById('password_reset')
        btn.blur()
        clearTimeout(a)
      }, 100)
    },
    closePasswordModal() {
      this.passwordModal = false
    },
    savePassword() {
      if (!this.password1) {
        this.openNotify('请填写密码')
        return
      }
      if (this.password1 != this.password2) {
        this.openNotify('密码填写不一致')
        return
      }
      if (!/^(\w){6,20}$/.test(this.password1)) {
        this.openNotify('密码格式填写有误')
        return
      }
      // this.openNotify(data.msg, 'success')
      let params = {
        password: this.password1,
      }
      api.passwordChange(params, (error, data) => {
        if (data.code === 0) {
          this.passwordModal = false
          this.openNotify('密码修改成功！', 'success')
          setTimeout(this.logout, 1000)
        } else {
          this.openNotify(data.msg)
        }
        // setTimeout(() => {
        //   this.$router.push({
        //     path: '/login',
        //   })
        // }, 1000)
      })
    },
    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
      return false
    },
  },
}
</script>
<style scoped></style>
